import { IOption, Option } from '@/interfaces/field';

export const GENDERS = [
    new Option('1', 'Feminino'),
    new Option('2', 'Masculino')
] as IOption[];